import { render } from "./IconRegenerate.vue?vue&type=template&id=29547e4f&ts=true"
import script from "./IconRegenerate.vue?vue&type=script&lang=ts"
export * from "./IconRegenerate.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__